import { CommissionRow } from './CommissionRow';

export class CommissionState {
  commissionFees: Array<any>;
  exchangeFees: Array<CommissionRow>;
  weeklyCommissionReports: any;
  monthlyCommissionReports: any;
}
